import { selectPendingDomains, selectPermissioningCache, useAppSelector } from '@ibk/shared-config';
import { hasDigitalAccountingParams, useRequiresAuthorization } from '@ibk/shared-permissioning';
import { PermissionsDomains, ResourceBehavior } from '@ibk/shared-types';
export function useDigitalAccountingAccess() {
    const permissioningCache = useAppSelector(selectPermissioningCache);
    const pendingDomains = useAppSelector(selectPendingDomains);
    useRequiresAuthorization(hasDigitalAccountingParams.domain, hasDigitalAccountingParams.resources, undefined, undefined, ResourceBehavior.OR);
    const domain = PermissionsDomains.DIGITAL_ACCOUNTING;
    const cachedResources = permissioningCache?.[domain];
    const isResolved = !pendingDomains.includes(domain) && !!cachedResources;
    const hasPermission = hasDigitalAccountingParams.resources.some(resource => cachedResources?.includes(resource));
    return { isResolved, hasPermission };
}
